import { render, staticRenderFns } from "./Kisbar.vue?vue&type=template&id=65d98fbc&scoped=true&"
import script from "./Kisbar.vue?vue&type=script&lang=js&"
export * from "./Kisbar.vue?vue&type=script&lang=js&"
import style0 from "./Kisbar.vue?vue&type=style&index=0&id=65d98fbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d98fbc",
  null
  
)

export default component.exports